import { type ProfileAccent, TEAM_ROLES } from "@/features/onboarding/data";
import type { TeamRole } from "@/features/onboarding/types";

export function roleLabel(role: string): string {
	return TEAM_ROLES.find((option) => option.id === role)?.label ?? role;
}

export function initials(name: string): string {
	const parts = name.trim().split(/\s+/).filter(Boolean);
	const first = parts[0]?.[0] ?? "";
	const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
	return (first + last).toUpperCase() || "?";
}

export type RoleAccent = ProfileAccent | "muted";

export const ROLE_ACCENT: Record<TeamRole, ProfileAccent> = {
	engineer: "primary",
	almoxarife: "warning",
	funcionario: "success",
	cliente: "violet",
};

const AVATAR_ACCENT_COUNT = 6;

export function memberAccent(name: string): number {
	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = (hash * 31 + name.charCodeAt(i)) | 0;
	}
	return (Math.abs(hash) % AVATAR_ACCENT_COUNT) + 1;
}

const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
	day: "2-digit",
	month: "short",
	year: "numeric",
});

export function formatDate(iso: string): string {
	const date = new Date(iso);
	if (Number.isNaN(date.getTime())) return "";
	return dateFormatter.format(date);
}
